import { SxProps, Theme } from '@mui/material';

type TElectronicSignatureStyles = {
  modalPaper: SxProps<Theme>;
};

type TSelectSignatureStyles = {
  title: SxProps<Theme>;
  cardsContainer: SxProps<Theme>;
  card: SxProps<Theme>;
  cardTopState: (isDisabled?: boolean) => SxProps<Theme>;
  cardContent: SxProps<Theme>;
  cardText: SxProps<Theme>;
  cardTextDiia: SxProps<Theme>;
  cardHeader: SxProps<Theme>;
  disabledMessage: SxProps<Theme>;
};

export const electronicSignatureStyles: TElectronicSignatureStyles = {
  modalPaper: (theme: Theme) => ({
    width: '40%',
    maxHeight: 'calc(100vh - 32px)',
    overflowY: 'auto',
    p: 3,
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.spacing(1),
    outline: 'none',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 16px)',
      maxHeight: 'calc(100vh - 16px)',
      p: 2,
    },
  }),
};

export const selectSignatureStyles: TSelectSignatureStyles = {
  title: {
    textAlign: 'center',
    mb: 2.5,
    fontWeight: 700,
  },
  cardsContainer: {
    display: 'flex',
    gap: 2,
    flexDirection: 'column',
  },
  card: (theme: Theme) => ({
    flex: 1,
    border: `1px solid ${theme.palette.grey.additionalGrey}`,
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
  }),
  cardTopState: (isDisabled = false) => (theme: Theme) => ({
    px: 2,
    py: 2.5,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.grey.additionalGrey}`,
    cursor: isDisabled ? 'not-allowed' : 'pointer',
    opacity: isDisabled ? 0.6 : 1,
  }),
  cardContent: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
  },
  cardText: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardTextDiia: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 44,
  },
  cardHeader: {
    fontWeight: 600,
    lineHeight: 1.2,
  },
  disabledMessage: {
    mt: 1,
    mb: 1.5,
    px: 2,
    fontSize: '12px',
    color: 'error.main',
  },
};
